import { fetchKayakServiceData } from 'api/resort/static';
import { IResortPathInfo } from 'api/resort/types';
import { getLocale } from 'i18n/locale';
import { ELocale } from 'i18n/localeEnum';
import { KayakServiceType } from 'util/kayakIntegrationUtils';

const KAYAK_AFFILIATE_CODE = 'kan_311305';

const KAYAK_LOCALES: Record<ELocale, string | null> = {
  [ELocale.EN_US]: 'www.kayak.com',
  [ELocale.FR_FR]: 'www.kayak.fr',
  [ELocale.IT_IT]: 'www.kayak.it',
  [ELocale.DE_DE]: 'www.kayak.de',
  [ELocale.PL_PL]: 'www.kayak.pl',
  [ELocale.NL_NL]: 'www.kayak.nl',
  [ELocale.NN_NO]: 'www.kayak.no',
  [ELocale.ES_ES]: 'www.kayak.es',
  [ELocale.SV_SE]: 'www.kayak.se',
  [ELocale.CS_CZ]: 'www.momondo.cz',
  [ELocale.DA_DK]: 'www.momondo.dk',

  // Default the rest to www.kayak.com
  [ELocale.SK_SK]: null,
  [ELocale.EN_GB]: null,
};

export function getKayakDomain() {
  const locale = getLocale() as ELocale;
  return KAYAK_LOCALES[locale];
}

export function getBookFlightsCb(resort: IResortPathInfo) {
  return () => {
    fetchKayakServiceData(resort.uuid, KayakServiceType.FLIGHTS).then((kayakIntegration) => {
      const domain = getKayakDomain();
      const url = `https://${domain}/in?a=${KAYAK_AFFILIATE_CODE}&url=%2Fflights-dateless%2F${kayakIntegration.to}`;
      window.location.href = url;
    });
  };
}

export function getCarRentalCallback(resort: IResortPathInfo) {
  return () => {
    fetchKayakServiceData(resort.uuid, KayakServiceType.FLIGHTS).then((kayakIntegration) => {
      const domain = getKayakDomain();
      const url = `https://${domain}/in?a=${KAYAK_AFFILIATE_CODE}&url=%2Fcars-dateless%2F${kayakIntegration.to} `;
      window.location.href = url;
    });
  };
}
